import React from 'react'
import SustainabilityStory from '../Components/analyst/SustainabilityStory'
import LeadershipMessage from '../Components/analyst/LeadershipMessage'
import EsgCommitments from '../Components/analyst/EsgCommitments'
import EsgHighlights from '../Components/analyst/EsgHighlights'
import OurPolicies from '../Components/analyst/OurPolicies'
import { Helmet } from "react-helmet-async";

function OurEsg() {
    return (
        <div>
            <Helmet>
    <title>
        Our ESG Vision | Sustainability & ESG Commitments | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode's ESG vision, sustainability initiatives, environmental commitments, responsible business practices, and policies focused on creating a sustainable future."
    />

    <meta
        name="keywords"
        content="Mobikode ESG, ESG Vision, ESG Commitments, Sustainability Mobikode, Environmental Sustainability, Social Responsibility, Corporate Governance, ESG Initiatives, Sustainable Business, ESG Policies, Sustainability Strategy, Responsible Business"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/our-esg"
    />

    <meta
        property="og:title"
        content="Our ESG Vision | Sustainability & ESG Commitments | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's ESG vision, sustainability commitments, responsible business practices, and initiatives designed to create long-term positive impact."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/our-esg"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/presence/bg2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Our ESG Vision | Sustainability & ESG Commitments | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Learn about Mobikode's ESG vision, sustainability story, environmental commitments, social responsibility, and governance practices."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/presence/bg2.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/presence/bg2.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] lg:max-w-[925px] mt-auto md:mt-0">
                        <h6 className="text-[#FFFFFF] max-w-[925px] w-full text-[24px] md:text-[58px] leading-[1.4] md:leading-[34px] lg:leading-[61.6px] font-sora font-[600] tracking-wider text-left opacity-90 lg:opacity-100">
                            Our ESG Vision: In Harmony with the Environment
                        </h6>
                    </div>
                </div>
            </section>
            <SustainabilityStory />
            <LeadershipMessage />
            <EsgCommitments />
            <EsgHighlights />
            <OurPolicies />
        </div>
    )
}

export default OurEsg
